<crm-alert #alert></crm-alert>
<div [ngSwitch]="rowStyle">
  <!-- Large -->
  <ng-container *ngSwitchCase="'L'">
    <div class="report"
      [ngClass]="{'isLoading': report.isLoading, 'border-none': isLast}">

      <!-- Loading -->
      <div class="relative">
        <div *ngIf="report.isLoading" class="large loading-wrapper">
          <span class="loading-icon-small" style="display: inline-table;"></span>
          <span class="text">Loading Report</span>
        </div>
      </div>

      <!-- Data -->
      <div class="row">
        <div id="largeDetails" class="col-lg-8 col-md-6">
          <div class="row">
            <!-- Company name + Tags -->

              <div class="col-md-8 d-flex pointer flexWrap">
                <right-click-menu class="w-100" [report]="report" [menuItems]="menuItems">
                  <div class="row d-flex" (click)="clickEvent(report)" (dblclick)="doubleClickEvent(report)">
                    <div class="d-flex col-md-6">
                     <report-notes-info *ngIf="report.NOTES_COUNT > 0" [report]="report"></report-notes-info>

                    <div class="hinted w-100">
                      <div class="ellipsis name">{{report.primaryEntity(user)}}</div>
                      <div *ngIf="report.REPORT_TYPE" class="hint" [ngSwitch]="report?.REPORT_TYPE">
                        <span *ngSwitchCase="ReportType.CONCLUSION">Business Valuation - Conclusion</span>
                        <span *ngSwitchCase="ReportType.CALCULATION">Business Valuation - Calculation</span>
                        <span *ngSwitchCase="ReportType.NO_SITE_VISIT">Equipment Appraisal - Desktop (no site visit)</span>
                        <span *ngSwitchCase="ReportType.WITH_SITE_VISIT">Equipment Appraisal - Summary (with site visit)</span>
                        <span *ngSwitchCase="ReportType.INVENTORY_APPRAISAL">Inventory Appraisal</span>
                        <span *ngSwitchCase="ReportType.LIQUOR_LICENSE">Liquor License Appraisal</span>
                      </div>
                    </div>
                  </div>
                    <div class="ml-2 col-md-2" *ngIf="showUnassigned()">
                      <tag tagName="Unassigned" [backGroundColor]="'#f50606'" [foreGroundColor]="'#ffffff'"></tag>
                    </div>

                    <div class="ml-2 col-md-1" *ngFor="let tag of report.TAGS;">
                      <tag (click)="onFilterChanged($event, tag)" [tagName]="tag.NAME" [backGroundColor]="tag.BACKGROUND_COLOR"
                        [foreGroundColor]="tag.FOREGROUND_COLOR" [abbrName]="tag.ABBREVIATE" [displayAbbr]="tag.DISPLAY_ABBR"></tag>
                    </div>

                    <div  class="copy-wrapper col-md-1" *ngIf="copied">
                      <span>Copied to Buffer</span>
                    </div>
                  </div>
                </right-click-menu>
              </div>


            <div class="col-md-4 d-flex hinted" [ngClass]="{'wrapped': report?.REPORT_QUOTE?.BANK_NAME || report?.CLIENT?.COMPANY_NAME}">
              <div class="name-bank clipped">{{report.IS_QUOTE ? report?.REPORT_QUOTE?.BANK_NAME : report?.CLIENT?.COMPANY_NAME}}</div>
              <div class="hint" *ngIf="report?.REPORT_QUOTE?.BANK_NAME || report?.CLIENT?.COMPANY_NAME">
                {{report.IS_QUOTE ? report?.REPORT_QUOTE?.BANK_NAME : report?.CLIENT?.COMPANY_NAME}}
              </div>
            </div>

            <!-- Date + Status -->
            <div class="col-md-12">
              <div class="d-flex">
                <div class="column date hinted" id="createdDate">
                  <div class="label-header">Created Date</div>
                  <div class="label-value">{{report?.DATE_CREATED | date: 'MM/dd/yyyy hh:mm a'}}</div>
                  <div class="hint">{{report?.DATE_CREATED | amTimeAgo}}</div>
                </div>

                <div class="column date hinted" id="updatedDate">
                  <div class="label-header" *ngIf="report?.DATE_UPDATED">Updated Date</div>
                  <div class="label-value">{{report?.DATE_UPDATED | date: 'MM/dd/yyyy hh:mm a'}}</div>
                  <div class="hint">{{report?.DATE_UPDATED | amTimeAgo}}</div>
                </div>

                <div class="column engage hinted">
                  <div class="label-header" *ngIf="report?.DATE_ENGAGED">Engaged Date</div>
                  <div class="label-value">{{report?.DATE_ENGAGED | date: 'MM/dd/yyyy'}}</div>
                  <div class="hint">{{report?.DATE_ENGAGED | date: 'MM/dd/yyyy'}}</div>
                </div>

                <div class="column relative due-date hinted">
                  <div class="label-header" *ngIf="report?.DATE_DUE">Due Date</div>
                  <div class="label-value">{{report?.DATE_DUE | formatdate}}</div>
                  <ng-container *ngIf="showDeadline(report.STATE)">
                    <div class="status-border"
                         [ngClass]="{'red': report.DATE_DUE_EXPIRED === true, 'green': report.DATE_DUE_DIFF <= 2 && report.DATE_DUE_EXPIRED !== true}"></div>

                    <div class="hint" *ngIf="report.DATE_DUE_DIFF">
                      {{report.DATE_DUE_EXPIRED === true ? 'Expired' : ('Deadline ' + (report.DATE_DUE_DIFF == 0 ? 'today' : 'in '+report.DATE_DUE_DIFF + ' days'))}}

                      <ng-container *ngIf="report.TURN_FROM !== report.TURN_TO">
                        <br/>
                        {{report?.DATE_DUE | formatdate}} - {{report?.DATE_DUE_TO | formatdate}}
                      </ng-container>
                    </div>
                  </ng-container>
                </div>

                <div class="relative due-date" id="fee">
                  <div class="label-header" *ngIf="report?.CHARGE">Fee</div>
                  <div class="label-value">{{report?.CHARGE ? ('$'+(report?.CHARGE | commPipe)) : ''}}</div>
                </div>

                <div class="relative due-date" id="turn">
                  <div class="label-header">Turn</div>
                  <div class="label-value">{{report?.TURN_FROM}}-{{report?.TURN_TO}}</div>
                </div>

                <div class="modules-column">
                  <div class="modules-header">Modules</div>
                  <div class="modules-container">
                    <div class="module hinted" (click)="viewInBVQ(report)"
                         [ngClass]="{'not-available': !report.HAS_BVQ}">
                      BVQ
                      <div class="hint">Business Valuation Questionnaire</div>
                    </div>

                    <!-- <div class="module hinted not-available">
                      F&S
                      <div class="hint">Financials & Spreading</div>
                    </div>
                    <div class="module hinted not-available">
                      R&D
                      <div class="hint">Research & Development</div>
                    </div> -->

                    <!-- Day Difference -->
                    <div class="hinted day-diff" *ngIf="report.DATE_ENGAGED && (report?.STATE.ID !== 'CMP' && report?.STATE.ID !== 'CCD' && report?.STATE.ID!== 'LST' && report.STATE.ID !== 'PRS' && report.STATE.ID !== 'TTQ')">
                      <div class="value">{{report.DAY_DIFF}}</div>
                      <div class="hint">{{report.DAY_DIFF}} day of Report </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <!-- Progress Bar -->
        <div id="largeProgress" class="col-lg-3 col-md-5 d-flex flex-column justify-content-center"
          *ngIf="!report.IS_QUOTE">
          <div class="stage-name">{{report?.STAGE?.NAME}}</div>
          <div class="status">{{report?.STATE?.NAME}}</div>
          <progress-indicator *ngIf="report.STAGE" [id]="report.ID" [stage]="report.STAGE" [state]="report.STATE" [delay]="report.ACTIVE_DELAY"></progress-indicator>
        </div>

        <!-- Quote Image -->
        <div class="col-lg-3 col-md-5 quote-file-l d-flex align-items-center"
          *ngIf="report.IS_QUOTE">
          <img src="../../../../../../assets/images/quote.png"/>
        </div>

        <!-- Avatar + Options report?.R_RESEARCH + report?.R_SPREAD -->
        <div id="largeAvatar" class="col-md-1 pr-2 d-flex align-items-center justify-content-end">
          <div class="researched-pos">
            <div class="hinted pointer" (click)="!report?.R_RESEARCH ? setResearched(report) : changeResearched(report)">
              <div class="researched mr-2 mb-2" [ngClass]="{'set': report?.R_RESEARCH}">R</div>
              <div class="hint" *ngIf="report?.R_RESEARCH">{{report?.R_RESEARCH?.FIRST_NAME + ' ' + report?.R_RESEARCH?.LAST_NAME}}</div>
            </div>

            <div class="hinted pointer" (click)="!report?.R_SPREAD ? setSpreaded(report) : changeSpreaded(report)">
              <div class="researched mr-2" [ngClass]="{'set': report?.R_SPREAD}">S</div>
              <div class="hint" *ngIf="report?.R_SPREAD">{{report?.R_SPREAD?.FIRST_NAME + ' ' + report?.R_SPREAD?.LAST_NAME}}</div>
            </div>
          </div>

          <div class="d-flex">
            <!-- Avatar -->
            <div *ngIf="report?.ASSIGNEE?.FIRST_NAME && report?.ASSIGNEE?.LAST_NAME">
              <app-assignee-profie-info [assignee]="report?.ASSIGNEE"></app-assignee-profie-info>
            </div>

            <!-- Options -->
            <ng-container [ngTemplateOutlet]="options" [ngTemplateOutletContext]="{report: report}"></ng-container>

          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Medium -->
  <ng-container *ngSwitchCase="'M'">
    <div class="report"
      [ngClass]="{'isLoading': report.isLoading, 'border-none': isLast}">
      <!-- Loading -->
      <div class="relative">
        <div *ngIf="report.isLoading" class="medium loading-wrapper">
          <span class="loading-icon-small" style="display: inline-table;"></span>
          <span class="text">Loading Report</span>
        </div>
      </div>

      <!-- Data -->
      <div class="row">
        <!-- Company Name + Tags -->
        <div class="col-md-4 pointer d-flex flexWrap" id="mediumCompanyName" (click)="clickEvent(report)" (dblclick)="doubleClickEvent(report)">
          <report-notes-info *ngIf="report.NOTES_COUNT > 0" [report]="report"></report-notes-info>
          <div class="ellipsis name">
            {{report.primaryEntity(user)}}
          </div>
          <div class="d-flex flexWrap">
            <div class="mr-2" *ngFor="let tag of report.TAGS;">
              <tag [tagName]="tag.NAME" [backGroundColor]="tag.BACKGROUND_COLOR"
                [foreGroundColor]="tag.FOREGROUND_COLOR" [abbrName]="tag.ABBREVIATE" [displayAbbr]="tag.DISPLAY_ABBR"></tag>
            </div>
          </div>
        </div>

        <!-- Client Name + Created Date + Engaged Date + Due Date -->
        <div class="col-md-4" id="mediumClientName">
          <div class="name">{{report?.CLIENT?.COMPANY_NAME}}</div>
          <div class="d-flex justify-content-between" [ngClass]="{'h-100 align-items-end': !report?.CLIENT?.COMPANY_NAME}">
            <div class="date hinted">
              <div class="label-value">{{report?.DATE_CREATED | date: 'MM/dd/yyyy hh:mm a'}}</div>
              <div class="hint">{{report?.DATE_CREATED | amTimeAgo}}</div>
            </div>
            <div class="engage hinted">
              <div class="label-value">{{report?.DATE_ENGAGED | date: 'MM/dd/yyyy'}}</div>
              <div class="hint">{{report?.DATE_ENGAGED | date: 'MM/dd/yyyy'}}</div>
            </div>
            <div class="relative due-date hinted">
              <div class="label-value">{{report?.DATE_DUE | formatdate}}</div>
              <ng-container *ngIf="showDeadline(report.STATE)">
                <div class="medium-border" [ngClass]="{'red': report.DATE_DUE_EXPIRED === true, 'green': report.DATE_DUE_DIFF <= 2 && report.DATE_DUE_EXPIRED !== true}"></div>
                <div class="hint">
                  {{report.DATE_DUE_EXPIRED === true ? 'Expired' : ('Deadline ' + (report.DATE_DUE_DIFF == 0 ? 'today' : 'in '+report.DATE_DUE_DIFF + ' days'))}}

                  <ng-container *ngIf="report.TURN_FROM !== report.TURN_TO">
                    <br/>
                    {{report?.DATE_DUE | formatdate}} - {{report?.DATE_DUE_TO | formatdate}}
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>
        </div>

        <!-- Stage Name + Status -->
        <div class="col-md-3" id="mediumProgress" *ngIf="!report.IS_QUOTE">
          <div class="stage-name">
            {{report?.STAGE?.NAME}}
          </div>

          <div class="status">
            {{report?.STATE?.NAME}}
          </div>
        </div>

        <!-- Quote Image -->
        <div id="mediumProgress" class="col-lg-3 quote-file-m d-flex align-items-center"
          *ngIf="report.IS_QUOTE">
          <img src="../../../../../../assets/images/quote.png"/>
        </div>

        <!-- Avatar + Option -->
        <div class="col-md-1 d-flex align-items-center justify-content-center">
          <div
            *ngIf="report?.ASSIGNEE?.FIRST_NAME && report?.ASSIGNEE?.LAST_NAME">
            <app-assignee-profie-info [assignee]="report?.ASSIGNEE"></app-assignee-profie-info>
          </div>

          <!-- Options -->
          <ng-container [ngTemplateOutlet]="options" [ngTemplateOutletContext]="{report: report, small: true}"></ng-container>

        </div>
      </div>
    </div>
  </ng-container>

  <!-- Small -->
  <ng-container *ngSwitchCase="'S'">
    <div class="report report-small" style="padding: 0px 10px;"
      [ngClass]="{'isLoading': report.isLoading, 'border-none': isLast}">
      <!-- Loading -->
      <div class="relative">
        <div *ngIf="report.isLoading" class="small loading-wrapper">
          <span class="loading-icon-small" style="display: inline-table;"></span>
          <span class="text">Loading Report</span>
        </div>
      </div>

      <!-- Row Data -->
      <div class="row ml-0 align-items-center">
        <!-- Company Name + Tag -->
        <div class="col-lg-5 col-md-5 d-flex pl-2 pointer flexWrap" (click)="clickEvent(report)" (dblclick)="doubleClickEvent(report)">
          <report-notes-info *ngIf="report.NOTES_COUNT > 0" [report]="report"></report-notes-info>
          <div class="ellipsis name">
            {{report.primaryEntity(user)}}
          </div>
          <div class="ml-2" *ngFor="let tag of report.TAGS;">
            <tag tagName="{{tag.DISPLAY_ABBR ? tag.NAME : tag.NAME | slice:0:1}}" [backGroundColor]="tag.BACKGROUND_COLOR"
              [foreGroundColor]="tag.FOREGROUND_COLOR" [abbrName]="tag.ABBREVIATE" [displayAbbr]="tag.DISPLAY_ABBR"></tag>
          </div>
        </div>

        <!-- Created Date -->
        <div class="col-md-2 hinted" id="smallCreatedDate">
          <div class="label-value">{{report?.DATE_CREATED | date: 'MM/dd/yyyy hh:mm a'}}</div>
          <div class="hint">{{report?.DATE_CREATED | amTimeAgo}} </div>
        </div>

        <!-- Engaged Date -->
        <div class="col-lg-1 col-md-2 hinted smallDates">
          <div class="label-value">{{report?.DATE_ENGAGED | date: 'MM/dd/yyyy'}}</div>
          <div class="hint">{{report?.DATE_ENGAGED | date: 'MM/dd/yyyy'}}</div>
        </div>

        <!-- Due Date -->
        <div class="col-lg-1 col-md-2 relative hinted smallDates">
          <div class="label-value">{{report?.DATE_DUE | formatdate}}</div>

          <ng-container *ngIf="showDeadline(report.STATE)">
            <div class="small-border" [ngClass]="{'red': report.DATE_DUE_EXPIRED === true, 'green': report.DATE_DUE_DIFF <= 2 && report.DATE_DUE_EXPIRED !== true}"></div>
            <div class="hint">
              {{report.DATE_DUE_EXPIRED === true ? 'Expired' : ('Deadline ' + (report.DATE_DUE_DIFF == 0 ? 'today' : 'in '+report.DATE_DUE_DIFF + ' days'))}}
              <ng-container *ngIf="report.TURN_FROM !== report.TURN_TO">
                <br/>
                {{report?.DATE_DUE | formatdate}} - {{report?.DATE_DUE_TO | formatdate}}
              </ng-container>
            </div>
          </ng-container>
        </div>

        <!-- Avatar + Options -->
        <div class="col-lg-3 col-md-3 pl-0 d-flex align-items-center justify-content-end"
          id="smallStage">
          <!-- Stage -->
          <div class="stage-name ellipsis" *ngIf="!report.IS_QUOTE">{{report?.STAGE?.NAME}}</div>

          <div class="ml-2 small d-flex align-items-center">
            <!-- Avatar -->
            <app-assignee-profie-info [assignee]="report?.ASSIGNEE" [size]="18"
              *ngIf="report?.ASSIGNEE?.FIRST_NAME && report?.ASSIGNEE?.LAST_NAME"></app-assignee-profie-info>

            <!-- Quote Image -->
            <img src="../../../../../../assets/images/quote.png" *ngIf="report.IS_QUOTE" class="quote-file-s"/>

            <!-- Options -->
            <ng-container [ngTemplateOutlet]="options" [ngTemplateOutletContext]="{report: report}"></ng-container>

          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #options let-report="report">
  <div class="btn-rbv-dropdown text-right" dropdown>
    <button dropdownToggle type="button" class="btn btn-default btn-sm sub">
      <fa class="check-block" name="fa fa-ellipsis-v"></fa>
    </button>

    <div *dropdownMenu class="drop-menu dropdown-menu-right" style="width: 200px;">
      <!-- Next Stage -->

      <a *ngIf="(report?.STATE.ID !== 'CMP' && report?.STATE.ID !== 'CCD' && report?.STATE.ID!== 'LST' && report.STATE.ID !== 'MRD' &&
      (currentMode === SystemType.BV ? report?.STAGE.ORDER > 6 : report?.STAGE?.ORDER > 5)) && !report.IS_QUOTE"
        class="drop-item" style="height: auto" (click)="onNextStage(report)">
        <fa class="check-block" name="fa fa-forward" style="width: 20px;"></fa>
        <div style="display: flex; flex-direction: column; align-items: flex-start;" class="info">
          <div class="item">Next Stage</div>

          <div class="item" style="font-size: 11px; color: black;">{{getNextStage(report)?.NAME}}</div>
        </div>
      </a>

      <!-- Stage -->
      <a *ngIf="(report?.STATE.ID !== 'CMP' && report?.STATE.ID !== 'CCD' && report?.STATE.ID!== 'LST' && report?.STATE.ID !== 'MRD') && !report.IS_QUOTE"
        class="drop-item" style="height: auto" (click)="changeStage(report)">
        <fa class="check-block" name="fa fa-arrow-right" style="width: 20px;"></fa>
        <div style="display: flex; flex-direction: column; align-items: flex-start;" class="info">
          <div class="item">Stage</div>
        </div>
      </a>

      <a class="drop-item" style="height: auto" (click)="assigneAnalyst(report)">
        <fa class="check-block" name="fa fa-user-o" style="width: 20px;"></fa>
        <div style="display: flex; flex-direction: column; align-items: flex-start;" class="info">
          <div class="item">Assign Analyst</div>
        </div>
      </a>

      <!-- Notes -->
      <a class="drop-item" (click)="setReportNote(report)" *ngIf="!report.IS_QUOTE">
        <fa class="check-block" name="fa fa-sticky-note-o" style="width: 20px"></fa>
        <div class="item">Notes</div>
      </a>

      <!-- Follow Ups -->
      <a class="drop-item" (click)="setFollowUp(report)" *ngIf="(currentMode === SystemType.BV ? report?.STAGE.ORDER < 7 : report?.STAGE.ORDER < 6)">
        <fa class="check-block" name="fa fa-sticky-note-o" style="width: 20px"></fa>
        <div class="item">Follow Ups</div>
      </a>

      <!-- Delay -->
      <a *ngIf="(report?.STATE.ID !== 'CMP' && report?.STATE.ID !== 'CCD' && report?.STATE.ID!== 'LST' && report.STATE.ID !== 'MRD' &&
        (currentMode === SystemType.BV ? report?.STAGE.ORDER > 6 : report?.STAGE?.ORDER > 5)) && !report.IS_QUOTE"
        class="drop-item" (click)="delayReport(report)">
        <fa class="check-block" name="fa fa-info-circle" style="width: 20px;color: red;"></fa>
        <div class="item">Delay</div>
      </a>

      <!-- Revert -->
      <a *ngIf="(report?.STATE.ID === 'CMP' || report?.STAGE.ORDER > 6) && !report.IS_QUOTE" class="drop-item" (click)="revertReport(report)">
        <fa class="check-block" name="fa fa-undo" style="width: 20px;color: red;"></fa>
        <div class="item">Revert</div>
      </a>

      <!-- Delete -->
      <a *ngIf="report.STAGE?.ORDER < 4" class="drop-item" (click)="deleteReport(report)">
        <fa class="check-block" name="fa fa-trash" style="width: 20px;color: red;"></fa>
        <div class="item">Delete</div>
      </a>

      <!-- To Template -->
      <a class="drop-item" (click)="openPageExportModal(PageExport)" *ngIf="!report.IS_QUOTE">
        <fa class="check-block" name="fa fa-upload" style="width: 20px;"></fa>
        <div class="item">To Template</div>
      </a>

      <!-- Duplicate -->
      <a class="drop-item" (click)="onDuplicate(report)" *ngIf="!report.IS_QUOTE">
        <fa class="check-block" name="fa fa-files-o" style="width: 20px;"></fa>
        <div class="item">Duplicate</div>
      </a>

      <!-- View in BVQ -->
      <a class="drop-item" (click)="viewInBVQ(report)" *ngIf="report.HAS_BVQ && currentMode === SystemType.BV">
        <fa class="check-block" name="fa fa-eye" style="width: 20px;"></fa>
        <div class="item">View in BVQ</div>
      </a>

      <!-- Transactional Database -->
      <a class="drop-item" (click)="viewInBVQDatabase(report)" *ngIf="report.HAS_BVQ">
        <fa class="check-block" name="fa fa-database" style="width: 20px;"></fa>
        <div class="item">Transactional Database</div>
      </a>

      <!-- Create BVQ -->
      <a class="drop-item" (click)="createBVQ(report)" *ngIf="!report.HAS_BVQ && currentMode === SystemType.BV && report.STAGE.ORDER >= 7">
        <fa class="check-block" name="fa fa-plus" style="width: 20px;"></fa>
        <div class="item">Create BVQ</div>
      </a>

      <!-- Tags -->
      <ng-container *ngFor="let tag of tags; let i = index">
        <a class="drop-item" (click)="setQuickTags(report, tag)">
          <fa class="check-block" name="fa fa-tag" style="width: 20px; color: orange; margin-right: 10px;"></fa>
          <tag [tagName]="tag.NAME" [backGroundColor]="tag.BACKGROUND_COLOR"
            [foreGroundColor]="tag.FOREGROUND_COLOR"></tag>
        </a>
      </ng-container>

    </div>
  </div>
</ng-template>

